import PropTypes from 'prop-types';
import React, { Fragment } from 'react'
import { Doughnut } from 'react-chartjs-2';
import { Card, Grid, Typography, Box, Stack, Container } from '@mui/material';
import Iconify from '../../components/iconify';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import EmptyContent from '../../components/empty-content';

Chart.register(ArcElement, Tooltip, Legend)

// Example data
const data = [
    { icon: 'mdi:youtube', label: 'YouTube', time: '25m', color: '#FF0000' },
    { icon: 'mdi:telegram', label: 'Telegram', time: '25m', color: '#0088CC' },
    { icon: 'mdi:microsoft-powerpoint', label: 'Microsoft PowerPoint', time: '25m', color: '#D24726' },
    { icon: 'mdi:microsoft-word', label: 'Microsoft Word', time: '25m', color: '#2B579A' },
];


// Options for the chart
const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            display: false, // Hide the default legend
        },
        tooltip: {
            enabled: true, // Enable tooltips on hover
        },
    },
};

const noData = (
    <Container sx={{ my: 10 }}>
        <EmptyContent
            filled
            title='No Data Available'

            sx={{ py: 10 }}
        />
    </Container>
);
export default function YourRecentActivity({ chartData }) {
    return (
        <Fragment>
            <Box sx={{ p: 2, mt: 5, backgroundColor: '#F1F1F1', borderRadius: 5, }}>

                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: "Sofia Sans Extra Condensed",
                        fontWeight: 700,
                        color: "#1E53E8",
                        textTransform: "uppercase",
                    }}
                >
                    YOUR RECENT ACTIVITY
                </Typography>
                {!chartData ? <Box sx={{ p: 5, mt: 3, backgroundColor: '#FFFFFF', borderRadius: 5, }}>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexDirection: 'column',
                            textAlign: 'center',
                            padding: 2,
                        }}
                    >
                        {/* Activity Heading */}
                        <Typography variant="h5" sx={{ fontSize: "28px", mb: 4, fontFamily: "Sofia Sans Extra Condensed", fontWeight: 800, }}>
                            YOUR ACTIVITY: <Typography variant="span" sx={{ color: '#1D53E7', fontFamily: "Sofia Sans Extra Condensed", fontWeight: 800, }}>1 HOURS 45 MINS</Typography>
                        </Typography>

                        {/* Chart Container */}
                        <Box sx={{ width: 250, height: 250, position: 'relative' }}>
                            {/* Donut Chart */}
                            <Doughnut data={chartData} options={options} />

                            {/* Centered Text */}
                            <Box
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 600 }}>
                                    Today
                                </Typography>
                                <Typography variant="h6" sx={{ fontSize: '16px', fontWeight: 600, color: '#1D53E7' }}>
                                    1 Hours 15 Min
                                </Typography>
                            </Box>
                        </Box>

                        {/* Labels for each section */}
                        {/* <Stack direction="row" justifyContent="space-around" sx={{ width: '100%', mt: 2 }}>
                            {chartData.labels.map((label, index) => (
                                <Typography key={index} variant="body2" sx={{ fontWeight: 500 }}>
                                    {label}
                                </Typography>
                            ))}
                        </Stack> */}
                    </Box>
                    <Grid container direction="column" spacing={2} sx={{ mt: 2 }}>
                        {data.map((item, index) => (
                            <Grid item xs={12} key={index}>
                                <Card
                                    sx={{
                                        backgroundColor: '#B7FFFE', // Light cyan background
                                        padding: '10px',
                                        borderRadius: '10px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        border: '1px solid #1D53E7', // Blue border
                                    }}
                                >
                                    {/* Left side with icon and label */}
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        {/* Icon */}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                backgroundColor: item.color,
                                                borderRadius: '50%',
                                                width: '40px',
                                                height: '40px',
                                            }}
                                        >
                                            <Iconify icon={item.icon} width={24} height={24} color="#FFF" />
                                        </Box>

                                        {/* Label */}
                                        <Typography variant="subtitle1" fontWeight="600" sx={{ color: '#000' }}>
                                            {item.label}
                                        </Typography>
                                    </Stack>

                                    {/* Right side with time */}
                                    <Typography variant="body1" fontWeight="600" sx={{ color: '#1D53E7' }}>
                                        {item.time}
                                    </Typography>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
                    : noData
                }
            </Box>
        </Fragment>

    )
}

YourRecentActivity.propTypes = {
    chartData: PropTypes.object,
};
